export const FIRST_G5X_ENCOUNTERED = "FIRST_G5X_ENCOUNTERED";
export const USER_CHOSEN_G5X = "USER_CHOSEN_G5X";
export const CENTER_OF_ROTATION = "CENTER_OF_ROTATION";

const constants = {
  FIRST_G5X_ENCOUNTERED,
  USER_CHOSEN_G5X,
  CENTER_OF_ROTATION
};

export default constants;
